import { createStyles } from 'antd-style'

interface ProgressStyleParams {
  color: string
}

export const useStyles = createStyles(
  ({ css, prefixCls }, { color }: ProgressStyleParams) => ({
    // Bar <-> value/icon group gap: sp10 for large/default, sp8 for small.
    barGapDefault: css`
      .${prefixCls}-progress-text {
        margin-inline-start: 10px;
      }
    `,

    barGapSmall: css`
      .${prefixCls}-progress-text {
        margin-inline-start: 8px;
      }
    `,

    barInfo: css`
      display: inline-flex;
      align-items: center;
      gap: 4px;
    `,

    barInfoSmall: css`
      font-size: 12px;
      line-height: 16px;
    `,

    barIcon: css`
      display: inline-flex;
      font-size: 16px;
      color: ${color};
    `,

    circle: css`
      display: inline-flex;
    `,

    circleValue: css`
      font-size: 14px;
    `,

    circleValueSmall: css`
      font-size: 12px;
    `,

    circleIcon: css`
      display: inline-flex;
      font-size: 16px;
      color: ${color};
    `
  })
)
